import { render, staticRenderFns } from "./TwAddTrading.vue?vue&type=template&id=6d1c1054&scoped=true&"
import script from "./TwAddTrading.vue?vue&type=script&lang=js&"
export * from "./TwAddTrading.vue?vue&type=script&lang=js&"
import style0 from "./TwAddTrading.vue?vue&type=style&index=0&id=6d1c1054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c1054",
  null
  
)

export default component.exports